<template>
    <div class="transcript">
        <div class="inner">
            <div class="highlight">
                <div class="level" v-if="!isInEvent">
                    <img
                        :src="require(`@/assets/Stage/Medal/${medal}.png`)"
                        alt=""
                    />
                    <div class="text">
                        <div class="label">等級</div>
                        <div class="data">LV{{ level }}</div>
                    </div>
                </div>
                <div class="data-block">
                    <img src="@/assets/Stage/score.png" alt="" />
                    <div class="text">
                        <div class="label">本次得分</div>
                        <div class="data">{{ currentScore }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 10px">
                <div class="label">本次總答對</div>
                <div class="data-block">
                    <span class="number">{{ correctNum }}</span>
                    <span class="suffix">題</span>
                </div>
            </div>
            <div v-if="!isInEvent">
                <div class="label">本次新答對</div>
                <div class="data-block">
                    <span class="number">{{ newCorrect }}</span>
                    <span class="suffix">題</span>
                </div>
            </div>
            <div>
                <div class="label">答對率</div>
                <div class="data-block">
                    <span class="number">{{ correctRate }}</span>
                    <span class="suffix">{{
                        correctRate !== undefined ? "％" : "-"
                    }}</span>
                </div>
            </div>
            <div v-if="!isInEvent">
                <div class="label">歷史最高分</div>
                <div class="data-block">
                    <span class="number">{{ highestScore || 0 }}</span>
                    <span class="suffix">分</span>
                </div>
            </div>
            <div v-if="!isInEvent">
                <div class="label">累積分數</div>
                <div class="data-block">
                    <span class="number">{{ score }}</span>
                    <span class="suffix">分</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Status from '@/mixins/Status';

export default {
    mixins: [Status],
    computed: {
        ...mapGetters(['isInEvent']),
        ...mapState({
            currentScore: (state) => state.score,
            newCorrect: (state) => state.newCorrect,
            correctNum: (state) => state.correctSet.length,
            inCorrectNum: (state) => state.incorrectSet.length,
            highestScore: (state) => {
                if (state.score > state.highestScore) {
                    return state.score;
                }
                return state.highestScore;
            },
            accumulatedScore: (state) => state.accumulatedScore,
        }),
        correctRate() {
            if (this.correctNum + this.inCorrectNum === 0) return undefined;
            const RATE = (this.correctNum / (this.correctNum + this.inCorrectNum)) * 100;
            return Math.round(RATE * 100) / 100;
        },
    },
};
</script>

<style lang="scss" scoped>
.transcript {
    margin-bottom: 20px;
    width: 75%;
    border-radius: 7px;
    box-shadow: 0 2px 11px 0 rgba(0, 152, 201, 0.37);
    padding-bottom: 10px;
    background-color: #fff;
    .inner {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: column;
        > * {
            display: flex;
            justify-content: space-between;
            > .label {
                font-size: 14px;
                color: #4683bc;
                font-weight: bold;
            }
        }
    }
    .highlight {
        width: 100%;
        display: flex;
        gap: 4%;
        justify-content: center;
        > * {
            flex: 1;
            height: 55px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            display: flex;
            align-items: center;
            text-align: center;
            img {
                margin-left: 8px;
                margin-right: 5px;
                width: 40px;
                height: 40px;
            }
            .text {
                flex: 1;
                overflow: hidden;
                font-weight: bold;
                font-size: 20px;
                > * {
                    width: 95%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .label {
                    font-size: 12px;
                }
            }
        }
        .level {
            background-image: linear-gradient(to bottom, #ffef77, #ffdb42);
        }
        .data-block {
            background-image: linear-gradient(to bottom, #f6cbff, #e99bff);
        }
    }
    @media screen and (max-width: 320px) {
        .inner > * > .data {
            font-size: 12px;
        }
        .highlight > * img {
            width: 30px;
            height: 30px;
        }
    }
}
</style>
